import { Status } from '#/components/Status';
import { useConfig, useDataContext } from '#/hooks';
import { AppStatus } from '#/service/constants';
import { ErrorCode } from '#/service/error/errors';

import PageController from '../PageController';

export const HomePage = () => {
  const { pages } = useConfig();
  const { getGeneralContext } = useDataContext();

  const homePageId = pages.HOME;

  if (!homePageId) {
    return <Status errorCode={ErrorCode.NoHome} status={AppStatus.Error} />;
  }

  const defaultContext = getGeneralContext();

  return <PageController defaultContext={defaultContext} pageId={homePageId} />;
};
